// Defines a user contact.
export class UserContact {
    // The contact ID.
	id: string;
	// The contact name.
	name: string;
	// The contact email address.
	emailAddress: string;
	// The contact phone number.
	phone: string;
}